var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-robbu"},[_c('img',{style:(_vm.resolvedStyle),attrs:{"src":require("@/assets/white-label/robbu/images/logo.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }